import { render } from "./page10.vue?vue&type=template&id=2670a858&scoped=true"
import script from "./page10.vue?vue&type=script&lang=js"
export * from "./page10.vue?vue&type=script&lang=js"

import "./page10.vue?vue&type=style&index=0&id=2670a858&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2670a858"]])

export default __exports__